
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class AdditionalChargesDialog extends Serenity.EntityDialog<AdditionalChargesRow, any> {
        protected getFormKey() { return AdditionalChargesForm.formKey; }
        protected getIdProperty() { return AdditionalChargesRow.idProperty; }
        protected getLocalTextPrefix() { return AdditionalChargesRow.localTextPrefix; }
        protected getNameProperty() { return AdditionalChargesRow.nameProperty; }
        protected getService() { return AdditionalChargesService.baseUrl; }
        protected getDeletePermission() { return AdditionalChargesRow.deletePermission; }
        protected getInsertPermission() { return AdditionalChargesRow.insertPermission; }
        protected getUpdatePermission() { return AdditionalChargesRow.updatePermission; }

        protected form = new AdditionalChargesForm(this.idPrefix);
        constructor() {
            super();
            q.setTextRightAlign(this.form.Rate);
            this.form.ApplicableOn.changeSelect2(e => {
                var applicableon = this.form.ApplicableOn.value;
                if (applicableon == "1") {
                    q.hideField(this.form.TransactionCalculateOn);
                    q.showAndSetRequiredField(this.form.ProductCalculateOn);
                    q.hideField(this.form.IncludeTax);
                }
                else if (applicableon == "2") {
                    q.hideField(this.form.ProductCalculateOn);
                    q.showAndSetRequiredField(this.form.TransactionCalculateOn);
                    q.showAndEnableField(this.form.IncludeTax);
                }
            });
        }
        protected onDialogOpen() {

            super.onDialogOpen();
            var applicableon = this.form.ApplicableOn.value;
            if (applicableon == "1") {
                q.hideField(this.form.TransactionCalculateOn);
                q.showAndSetRequiredField(this.form.ProductCalculateOn);
                q.hideField(this.form.IncludeTax);
            }
            else if (applicableon == "2") {
                q.hideField(this.form.ProductCalculateOn);
                q.showAndSetRequiredField(this.form.TransactionCalculateOn);
                q.showAndEnableField(this.form.IncludeTax);
            }
            else {
                q.hideField(this.form.TransactionCalculateOn);
                q.hideField(this.form.ProductCalculateOn);
                q.hideField(this.form.IncludeTax);
            }
        }
    }
}